import "./FormSubmission.css";
import SubmissionDynamicform from "./submissionDynamicform";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
const PopupDynamicForm = ({
  ModalIsOpen,
  DynamicFormId,
  setIsModelPopup,
  RefreshSelect,
}) => {
  const [popup, setpopup] = useState(true);

  return (
    <div className="dialog-form-popup">
      <Dialog
        open={ModalIsOpen}
        fullWidth={true}
        aria-labelledby="custom-dialog-title"
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
            maxWidth:'calc(100% - 64px)'
          },
        }}
      >
        <div className="content-overview-container"
        style={{paddingTop:0,marginBottom:'0px'}}>
          <SubmissionDynamicform
            ModalIsOpen={ModalIsOpen}
            DynamicFormId={DynamicFormId}
            setIsModelPopup={setIsModelPopup}
            popup={popup}
            setpopup={setpopup}
            RefreshSelect={RefreshSelect}
            // routeParams={routeParams}
          />
          {/* {SubmissionDynamicform(ModalIsOpen,DynamicFormId)} */}
        </div>
      </Dialog>
    </div>
  );
};

export default PopupDynamicForm;
